// eslint-disable-next-line import/no-named-as-default
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import { STORAGE_KEYS } from '@/constants';

import en from './locales/en.json';
import es from './locales/es.json';

export const defaultNS = 'common';
export const resources = {
  en: { common: en },
  es: { common: es },
} as const;

export const supportedLanguages = [
  { code: 'en', name: 'English', nativeName: 'English' },
  { code: 'es', name: 'Spanish', nativeName: 'Español' },
] as const;
const savedLanguage = localStorage.getItem(STORAGE_KEYS.language);

// eslint-disable-next-line import/no-named-as-default-member
void i18n.use(initReactI18next).init({
  resources,
  lng: savedLanguage ?? 'en',
  fallbackLng: 'en',
  defaultNS,
  ns: ['common'],
  interpolation: {
    escapeValue: false,
  },
  react: {
    useSuspense: true,
  },
  detection: {
    order: ['localStorage', 'navigator'],
    caches: ['localStorage'],
  },
});

export const changeLanguage = async (language: string) => {
  // eslint-disable-next-line import/no-named-as-default-member
  await i18n.changeLanguage(language);
  localStorage.setItem(STORAGE_KEYS.language, language);
};

export default i18n;
